import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h2", { class: "font-semibold text-xl text-gray-800 leading-tight" }, " ユーザ管理 ", -1);
const _hoisted_2 = { class: "max-w-7xl mx-auto py-10 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "grid grid-cols-12 gap-4" };
const _hoisted_4 = { class: "col-span-3 flex-col" };
const _hoisted_5 = { class: "col-span-9" };
const _hoisted_6 = { class: "flex justify-end mb-4" };
const _hoisted_7 = ["disabled"];
const _hoisted_8 = ["disabled"];
const _hoisted_9 = { class: "grid grid-cols-3 flex py-2 text-gray-600 mb-2" };
const _hoisted_10 = { class: "col-span-3" };
const _hoisted_11 = /*#__PURE__*/ _createTextVNode(" PerPage: ");
const _hoisted_12 = ["value"];
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "mb-5" };
const _hoisted_15 = { class: "mb-2 grid grid-cols-12 gap-2" };
const _hoisted_16 = { class: "mb-4 grid grid-cols-12 gap-2 items-center" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "全て", -1);
const _hoisted_18 = ["value"];
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "全て", -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("option", { value: "linked" }, "学校連携済み", -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("option", { value: "not_linked" }, "未連携", -1);
const _hoisted_22 = [
    _hoisted_19,
    _hoisted_20,
    _hoisted_21
];
import { Inertia } from '@inertiajs/inertia';
import { ref, toRef } from 'vue';
import AppLayout from '@/Layouts/AppLayout.vue';
import ExaminationMenu from '../Partials/ExaminationMenu.vue';
import ClientsList from './ClientsList.vue';
import useClients from '@/types/composables/useClients';
import useClientForm from '@/types/composables/useClientForm';
import UserExaminationModal from './UserExaminationModal.vue';
import route from '@/types/Route';
export default /*#__PURE__*/ _defineComponent({
    props: {
        examinations: null,
        examination: null,
        pagination: null,
        schools: null,
        userId: null,
        name: null,
        email: null,
        school: null,
        linkedStatus: null,
        isPurchase: null,
        limit: null
    },
    setup(__props) {
        const props = __props;
        const selectedUsers = ref([]);
        const resetSelection = ref(false);
        // perPageの選択肢
        const paginatePerPages = [10, 15, 20, 50, 100];
        // モーダル関連の状態
        const modalShow = ref(false);
        const modalMode = ref('add');
        // Composablesを使用
        const { examination, pagination, schools, userId, name, email, school, linkedStatus, isPurchase, limit, } = useClients();
        // モーダルを閉じる
        const closeModal = () => {
            modalShow.value = false;
        };
        // onSearchButtonClicked  検索ボタン
        // onResetButtonClicked リセットボタン
        // onAddExaminationToUsersClicked  選択したユーザに模試を付与
        // ondeleteExaminationFromUsersClicked 選択したユーザの模試を削除
        const { form, onSearchButtonClicked, onResetButtonClicked, onAddExaminationToUsersClicked, ondeleteExaminationFromUsersClicked, } = useClientForm(toRef(props, 'examination'), {
            userId: props.userId,
            name: props.name,
            email: props.email,
            selectedSchool: props.school,
            linkedStatus: props.linkedStatus,
        }, props.limit, selectedUsers, resetSelection, closeModal);
        // ページネーションのPerpageの変更時の処理
        const onChangedPerPage = (e) => {
            const target = e.target;
            Inertia.get(route('examinations.showAddExamination', {
                examination: props.examination.id,
                limit: target.value,
            }), {
                only: ['pagination'],
            });
        };
        const onSelectUsers = (users) => {
            selectedUsers.value = users;
        };
        // モーダルを開く追加と削除
        const openModal = (mode) => {
            modalMode.value = mode;
            modalShow.value = true;
        };
        // モーダルでのアクション実行
        const handleModalAction = () => {
            if (modalMode.value === 'add') {
                onAddExaminationToUsersClicked();
            }
            else {
                ondeleteExaminationFromUsersClicked();
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppLayout, { title: "ユーザ管理" }, {
                header: _withCtx(() => [
                    _hoisted_1
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", null, [
                                    _createVNode(ExaminationMenu, {
                                        examinations: __props.examinations,
                                        "selected-examination": _unref(examination),
                                        "route-name": "examinations.showAddExamination"
                                    }, null, 8, ["examinations", "selected-examination"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        disabled: !selectedUsers.value.length,
                                        class: "px-8 py-2 mx-2 rounded bg-green-500 text-red-50 max-w-max shadow-sm hover:shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed",
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (openModal('add')), ["prevent"]))
                                    }, " 選択したユーザに模試を付与 ", 8, _hoisted_7),
                                    _createElementVNode("button", {
                                        disabled: !selectedUsers.value.length,
                                        class: "px-8 py-2 rounded bg-red-500 text-red-50 max-w-max shadow-sm hover:shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (openModal('remove')), ["prevent"]))
                                    }, " 選択したユーザの模試を削除 ", 8, _hoisted_8)
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _hoisted_11,
                                        _createElementVNode("select", {
                                            value: _unref(limit),
                                            class: "ml-2 pl-2 rounded border-gray-400",
                                            onChange: onChangedPerPage
                                        }, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paginatePerPages, (perPage) => {
                                                return _createElementVNode("option", {
                                                    key: perPage,
                                                    value: perPage
                                                }, _toDisplayString(perPage), 9, _hoisted_13);
                                            }), 64))
                                        ], 40, _hoisted_12)
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(examination).title), 1)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).userId) = $event)),
                                        type: "search",
                                        class: "col-span-3 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none",
                                        placeholder: "ユーザID"
                                    }, null, 512), [
                                        [_vModelText, _unref(form).userId]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).name) = $event)),
                                        type: "search",
                                        class: "col-span-3 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none",
                                        placeholder: "名前"
                                    }, null, 512), [
                                        [_vModelText, _unref(form).name]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).email) = $event)),
                                        type: "search",
                                        class: "col-span-6 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none",
                                        placeholder: "メールアドレス"
                                    }, null, 512), [
                                        [_vModelText, _unref(form).email]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _withDirectives(_createElementVNode("select", {
                                        id: "school_name",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).selectedSchool) = $event)),
                                        class: "col-span-3 border border-gray-300 outline-none rounded-md bg-white placeholder-gray-400 text-gray-500 focus:outline-none"
                                    }, [
                                        _hoisted_17,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schools), (school) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: school.id,
                                                value: school.name
                                            }, _toDisplayString(school.name), 9, _hoisted_18));
                                        }), 128))
                                    ], 512), [
                                        [_vModelSelect, _unref(form).selectedSchool]
                                    ]),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).linkedStatus) = $event)),
                                        class: "col-span-3 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white text-gray-500 appearance-none w-full block focus:outline-none"
                                    }, _hoisted_22, 512), [
                                        [_vModelSelect, _unref(form).linkedStatus]
                                    ]),
                                    _createElementVNode("button", {
                                        class: "col-span-2 px-6 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                                        onClick: _cache[7] || (_cache[7] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_unref(onSearchButtonClicked) && _unref(onSearchButtonClicked)(...args)), ["prevent"]))
                                    }, " 検索 "),
                                    _createElementVNode("button", {
                                        class: "col-span-2 bg-white hover:bg-gray-100 text-black py-2 border border-gray-200 rounded shadow",
                                        onClick: _cache[8] || (_cache[8] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_unref(onResetButtonClicked) && _unref(onResetButtonClicked)(...args)), ["prevent"]))
                                    }, " リセット ")
                                ]),
                                _createVNode(ClientsList, {
                                    pagination: _unref(pagination),
                                    examination: _unref(examination),
                                    limit: _unref(limit),
                                    "user-id": _unref(userId),
                                    name: _unref(name),
                                    email: _unref(email),
                                    school: _unref(school),
                                    "linked-status": _unref(linkedStatus),
                                    "is-purchase": _unref(isPurchase),
                                    "reset-selection": resetSelection.value,
                                    onSelectUsers: onSelectUsers
                                }, null, 8, ["pagination", "examination", "limit", "user-id", "name", "email", "school", "linked-status", "is-purchase", "reset-selection"])
                            ])
                        ])
                    ]),
                    _createVNode(UserExaminationModal, {
                        show: modalShow.value,
                        "selected-users": selectedUsers.value,
                        mode: modalMode.value,
                        onClose: closeModal,
                        onAction: handleModalAction
                    }, null, 8, ["show", "selected-users", "mode"])
                ]),
                _: 1
            }));
        };
    }
});
